import React, { useState } from 'react';
import { isPresent } from 'utils/helperMethods';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import useApp from 'reducers/hooks/useApp';

import { Dialog, DialogContent, Button, Typography, Box, Avatar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Jane from 'public/images/jane.jpg';
import Icon from 'sharedComponents/Icon';
import useScreen from 'hooks/useScreen';

import BuyerRegistration from './components/BuyerRegistration';
import LoanOfficerRegistration from './components/LoanOfficerRegistration';
import RealEstateAgentRegistration from './components/RealEstateAgentRegistration';

import useStyles from './useStyles';

const SignUp = props => {
  const { onClose } = props;

  const { loadCurrentUser } = useApp();
  const classes = useStyles();
  const { t } = useTranslation();
  const { isMobile } = useScreen();
  const [selectedUserType, setSelectedUserType] = useState(null);
  const isUserTypeSelected = isPresent(selectedUserType);

  const handleSelectUserType = type => () => setSelectedUserType(type);
  const handleBack = () => setSelectedUserType(null);
  const handleFinish = () => {
    loadCurrentUser();
    onClose();
  };

  const registrationComponentsMapper = {
    buyer: BuyerRegistration,
    loanOfficer: LoanOfficerRegistration,
    realEstateAgent: RealEstateAgentRegistration,
  };

  const RegistrationComponent = registrationComponentsMapper[selectedUserType];

  return (
    <div>
      <Dialog open onClose={onClose} fullScreen={isMobile}>
        <div className={classes.closeContainer}>
          <Icon name="logo" width="100" />
          <CloseIcon className={classes.dialogClose} onClick={onClose} />
        </div>
        <div className={classes.avatarContainer}>
          <Avatar src={Jane} className={classes.avatar} variant="rounded" />
        </div>
        <DialogContent>
          {isUserTypeSelected ? (
            <div>
              <RegistrationComponent onFinish={handleFinish} />
              <Box className={classes.back} onClick={handleBack}>
                <ArrowBackIosIcon className={classes.backButton} />
                <Typography variant="body1">{t('components.SignUp.signUpBack')}</Typography>
              </Box>
            </div>
          ) : (
            <div className={classes.selectionBox}>
              <Typography className={classes.selectionHeader} variant="h1">
                {t('components.SignUp.createAnAccount')}
              </Typography>
              <Button onClick={handleSelectUserType('buyer')} className={classes.button}>
                {t('models.App.userTypes.buyer')}
              </Button>
              <Button
                onClick={handleSelectUserType('loanOfficer')}
                className={classes.buttonSecondary}
                variant="outlined"
              >
                {t('models.App.userTypes.loanOfficer')}
              </Button>
              <Button
                onClick={handleSelectUserType('realEstateAgent')}
                className={classes.buttonSecondary}
                variant="outlined"
              >
                {t('models.App.userTypes.realEstateAgent')}
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

SignUp.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default SignUp;



// WEBPACK FOOTER //
// ./src/components/SignUp/SignUp.js